__turbopack_context__.v({
  "btnApply": "NarrationPanel-module__teitNW__btnApply",
  "centerBar": "NarrationPanel-module__teitNW__centerBar",
  "centerSub": "NarrationPanel-module__teitNW__centerSub",
  "centerTitle": "NarrationPanel-module__teitNW__centerTitle",
  "cloneBtn": "NarrationPanel-module__teitNW__cloneBtn",
  "hBack": "NarrationPanel-module__teitNW__hBack",
  "hBalance": "NarrationPanel-module__teitNW__hBalance",
  "hMeta": "NarrationPanel-module__teitNW__hMeta",
  "hTitle": "NarrationPanel-module__teitNW__hTitle",
  "mmlTag": "NarrationPanel-module__teitNW__mmlTag",
  "modeCard": "NarrationPanel-module__teitNW__modeCard",
  "modeCardHead": "NarrationPanel-module__teitNW__modeCardHead",
  "modeCardOn": "NarrationPanel-module__teitNW__modeCardOn",
  "modeDesc": "NarrationPanel-module__teitNW__modeDesc",
  "modePill": "NarrationPanel-module__teitNW__modePill",
  "modeRadio": "NarrationPanel-module__teitNW__modeRadio",
  "modeTitle": "NarrationPanel-module__teitNW__modeTitle",
  "nr": "NarrationPanel-module__teitNW__nr",
  "nrCenter": "NarrationPanel-module__teitNW__nrCenter",
  "nrHeader": "NarrationPanel-module__teitNW__nrHeader",
  "nrMain": "NarrationPanel-module__teitNW__nrMain",
  "nrRight": "NarrationPanel-module__teitNW__nrRight",
  "nrSide": "NarrationPanel-module__teitNW__nrSide",
  "rightBlock": "NarrationPanel-module__teitNW__rightBlock",
  "rightTitle": "NarrationPanel-module__teitNW__rightTitle",
  "scriptBox": "NarrationPanel-module__teitNW__scriptBox",
  "scriptTextarea": "NarrationPanel-module__teitNW__scriptTextarea",
  "sectionCount": "NarrationPanel-module__teitNW__sectionCount",
  "sectionH": "NarrationPanel-module__teitNW__sectionH",
  "sideBlock": "NarrationPanel-module__teitNW__sideBlock",
  "sideTitle": "NarrationPanel-module__teitNW__sideTitle",
  "srOnly": "NarrationPanel-module__teitNW__srOnly",
  "subRadio": "NarrationPanel-module__teitNW__subRadio",
  "submode": "NarrationPanel-module__teitNW__submode",
  "submodeOn": "NarrationPanel-module__teitNW__submodeOn",
  "sumRow": "NarrationPanel-module__teitNW__sumRow",
  "sumTotal": "NarrationPanel-module__teitNW__sumTotal",
  "sumVal": "NarrationPanel-module__teitNW__sumVal",
  "summary": "NarrationPanel-module__teitNW__summary",
  "themeCard": "NarrationPanel-module__teitNW__themeCard",
  "themeCardOn": "NarrationPanel-module__teitNW__themeCardOn",
  "themeGrid": "NarrationPanel-module__teitNW__themeGrid",
  "themeIco": "NarrationPanel-module__teitNW__themeIco",
  "themeName": "NarrationPanel-module__teitNW__themeName",
  "themeTag": "NarrationPanel-module__teitNW__themeTag",
  "toneCard": "NarrationPanel-module__teitNW__toneCard",
  "toneCardOn": "NarrationPanel-module__teitNW__toneCardOn",
  "toneEn": "NarrationPanel-module__teitNW__toneEn",
  "toneGrid": "NarrationPanel-module__teitNW__toneGrid",
  "toneIco": "NarrationPanel-module__teitNW__toneIco",
  "toneName": "NarrationPanel-module__teitNW__toneName",
  "voiceAvatar": "NarrationPanel-module__teitNW__voiceAvatar",
  "voiceAvatar_clone": "NarrationPanel-module__teitNW__voiceAvatar_clone",
  "voiceAvatar_f1": "NarrationPanel-module__teitNW__voiceAvatar_f1",
  "voiceAvatar_f2": "NarrationPanel-module__teitNW__voiceAvatar_f2",
  "voiceAvatar_f3": "NarrationPanel-module__teitNW__voiceAvatar_f3",
  "voiceAvatar_m1": "NarrationPanel-module__teitNW__voiceAvatar_m1",
  "voiceAvatar_m2": "NarrationPanel-module__teitNW__voiceAvatar_m2",
  "voiceGender": "NarrationPanel-module__teitNW__voiceGender",
  "voiceInfo": "NarrationPanel-module__teitNW__voiceInfo",
  "voiceList": "NarrationPanel-module__teitNW__voiceList",
  "voiceMeta": "NarrationPanel-module__teitNW__voiceMeta",
  "voiceName": "NarrationPanel-module__teitNW__voiceName",
  "voicePlay": "NarrationPanel-module__teitNW__voicePlay",
  "voiceRow": "NarrationPanel-module__teitNW__voiceRow",
  "voiceRowOn": "NarrationPanel-module__teitNW__voiceRowOn",
  "voiceStatus": "NarrationPanel-module__teitNW__voiceStatus",
  "wizardActions": "NarrationPanel-module__teitNW__wizardActions",
  "wizardBackdrop": "NarrationPanel-module__teitNW__wizardBackdrop",
  "wizardBody": "NarrationPanel-module__teitNW__wizardBody",
  "wizardBtnGhost": "NarrationPanel-module__teitNW__wizardBtnGhost",
  "wizardBtnPrimary": "NarrationPanel-module__teitNW__wizardBtnPrimary",
  "wizardClose": "NarrationPanel-module__teitNW__wizardClose",
  "wizardField": "NarrationPanel-module__teitNW__wizardField",
  "wizardFieldLabel": "NarrationPanel-module__teitNW__wizardFieldLabel",
  "wizardHeader": "NarrationPanel-module__teitNW__wizardHeader",
  "wizardLead": "NarrationPanel-module__teitNW__wizardLead",
  "wizardModal": "NarrationPanel-module__teitNW__wizardModal",
  "wizardProgress": "NarrationPanel-module__teitNW__wizardProgress",
  "wizardProgressBar": "NarrationPanel-module__teitNW__wizardProgressBar",
  "wizardProgressLabel": "NarrationPanel-module__teitNW__wizardProgressLabel",
  "wizardStep": "NarrationPanel-module__teitNW__wizardStep",
  "wizardStepDone": "NarrationPanel-module__teitNW__wizardStepDone",
  "wizardStepNum": "NarrationPanel-module__teitNW__wizardStepNum",
  "wizardStepOn": "NarrationPanel-module__teitNW__wizardStepOn",
  "wizardSteps": "NarrationPanel-module__teitNW__wizardSteps",
  "wizardTitle": "NarrationPanel-module__teitNW__wizardTitle",
  "wizardUpload": "NarrationPanel-module__teitNW__wizardUpload",
});
